module.exports = __webpack_public_path__ + "images/f658e98bb006e3d4ed987f8e4341a87e.svg";